import React from 'react';
import { makeStyles } from '@material-ui/core';

import { theme } from 'config/theme';
import TableMapsTable from './components/TableMapsTable';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.common.white,
    },
});

export default function TableMapsPage() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <TableMapsTable />
        </div>
    );
}
